export const URLs = {
  dev: {
    auth: 'http://localhost:8080',
    contactManager: 'https://localhost:3443',
    eventManager: 'https://localhost:2443',
    origin: 'http://localhost:4200',
    reservationManager: 'https://localhost:4443',
    send: 'https://localhost:6443',
    stringer: 'https://localhost:5443',
  },
  prod: {
    auth: 'https://auth.sideline-apps.com',
    contactManager: 'https://contact-manager.connect.sideline-apps.net',
    eventManager: 'https://event-manager.connect.sideline-apps.net',
    origin: 'https://admin.sideline-apps.com',
    reservationManager: 'https://reservation-manager.connect.sideline-apps.net',
    send: 'https://send.sideline-apps.net',
    stringer: 'https://stringer.connect.sideline-apps.net',
  }
};
